const info = [
  { label: "事業者名", value: "京都ゴミ処分センター" },
  { label: "所在地", value: "〒612-8449 京都府京都市伏見区竹田西小屋ノ内町13" },
  { label: "電話番号", value: "0120-02-4747" },
  { label: "営業時間", value: "9:00〜17:00" },
  { label: "定休日", value: "年中無休" },
  {
    label: "事業内容",
    value: "不用品回収 / 遺品整理 / ゴミ屋敷清掃 / 残置物撤去 / 産業廃棄物収集運搬",
  },
];

const trustItems = [
  "京都府知事 一般廃棄物・産業廃棄物収集運搬業許可 取得済み",
  "お見積り後の追加料金は一切ありません",
  "分別・搬出・積み込みまでスタッフがワンストップ対応",
  "お見積りは完全無料",
];

export default function Trust() {
  return (
    <section id="trust" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            ABOUT US
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            運営会社・
            <span className="text-primary-500">安心してご依頼いただくために</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都ゴミ処分センターは、京都府知事の許可を取得した不用品回収・産廃回収の事業者です。
            法令に則った適正な回収・処分で、安心してご依頼いただけます。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6 items-start">
          <div className="rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
            <div className="w-14 h-14 flex items-center justify-center rounded-md bg-primary-100 mb-6">
              <i className="ri-shield-check-line text-primary-600 text-2xl"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-4">
              許可を取得した事業者です
            </h3>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              「京都府知事 一般廃棄物・産業廃棄物収集運搬業許可」を取得しています。
              家庭の不用品回収・粗大ゴミ処分から事業系の産廃まで、法令に則り適正に回収・処分いたします。
            </p>
            <ul className="space-y-3">
              {trustItems.map((t) => (
                <li
                  key={t}
                  className="flex items-start gap-2.5 text-sm md:text-base text-foreground-800"
                >
                  <span className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-600 shrink-0">
                    <i className="ri-checkbox-circle-fill"></i>
                  </span>
                  <span className="leading-relaxed">{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
            <table className="w-full text-sm md:text-base">
              <tbody>
                {info.map((row) => (
                  <tr
                    key={row.label}
                    className="border-b border-background-200 last:border-b-0"
                  >
                    <th className="w-28 md:w-36 px-5 md:px-6 py-4 bg-secondary-100 text-secondary-900 text-left font-bold align-top whitespace-nowrap">
                      {row.label}
                    </th>
                    <td className="px-5 md:px-6 py-4 text-foreground-800 leading-relaxed">
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}